import { render, staticRenderFns } from "./bookerCars.vue?vue&type=template&id=54391536&scoped=true"
import script from "./bookerCars.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerCars.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerCars.vue?vue&type=style&index=0&id=54391536&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54391536",
  null
  
)

export default component.exports